
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`ECL 2.0 is a continuous work in progress. The template and components for the Europa.eu website, including for sites under the EU web presence, are being redesigned. The new look and feel will be launched in 2019. The mandatory components for sites in the EU web presence : site header, and footer are available today.`}</p>
    <p>{`We also have a campaign template available in the Europa Component Library.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;